import React, { Component } from 'react';
import styled from 'styled-components';
import dynamic from 'next/dynamic';
import { Dropdown } from 'antd';
const EmojiPicker = dynamic(() => import('./EmojiPicker'), {
  ssr: false
});

const MaterialIconButton = styled.i`
  color: #7d7878;
  border-radius: 50%;
  padding: 0px 5px;

  &:hover {
    background: #e0e0e0;
    cursor: pointer;
  }
`;

class EmojiButton extends Component {
  constructor(props) {
    super(props);

    this.state = {
      emojiPickerOpened: false
    };
  }

  onEmojiSelect = (e) => {
    if (typeof this.props.onEmojiSelect === 'function') {
      this.props.onEmojiSelect(e.native ?? e.colons);
    }

    this.setState({ emojiPickerOpened: false });
  };

  onEmojiButtonClick = () => {
    this.setState({ emojiPickerOpened: !this.state.emojiPickerOpened });
  };

  handleVisibleChange = (flag) => {
    this.setState({ emojiPickerOpened: flag });
  };

  render() {
    return (
      <Dropdown
        overlay={<EmojiPicker onEmojiSelect={this.onEmojiSelect} />}
        onVisibleChange={this.handleVisibleChange}
        trigger={['click']}
        visible={this.state.emojiPickerOpened}
      >
        <MaterialIconButton className='material-icons' onClick={this.onEmojiButtonClick}>
          sentiment_satisfied_alt
        </MaterialIconButton>
      </Dropdown>
    );
  }
}

export default EmojiButton;
